<template>
  <main class="w-full h-full">
    <slot />
  </main>
</template>

<script setup lang="ts">
</script>
